import React from "react";
import PayerTransactionSummary from "@app.automotus.io/components/Dashboard/PayerTransactionSummary";
import { Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useUserProfile } from "@app.automotus.io/components/hooks";
import { PayerTransactionsTable } from "@app.automotus.io/components/PayerTransactionsTable";
import { computeDisputedTransactionAccess } from "@app.automotus.io/components/PayerTransactionsTable/disputedTransactionsAccess";
import { PayerOverview } from "@app.automotus.io/components/PayerOverview";

export const PayerDashboard: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <PayerTransactionSummary />
      <Box
        sx={{
          bgcolor: (theme: Theme) => theme.palette.grey[100],
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <Payments />
      </Box>
    </Box>
  );
};

const Payments: React.FC = () => {
  const { userProfile } = useUserProfile();
  const wallet = userProfile?.account.wallets[0];
  const paymentPreference = wallet?.paymentPreference;
  const walletBalance = paymentPreference === "session" ? undefined : wallet?.status?.balance;
  // AUT-5627: tab visibility is broad (any confirmed Philly bus carrier); the row data is narrow
  // (only the one carrier these 4 hardcoded transactions actually belong to). See
  // computeDisputedTransactionAccess's own tests for the access-decision logic itself.
  const { showDisputedTransactions, showDisputedTransactionRows } = computeDisputedTransactionAccess(
    userProfile?.account.id,
  );

  return (
    <>
      <PayerOverview walletBalance={walletBalance} />
      <Box sx={{ py: 4, display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Container maxWidth="xl" sx={{ display: "flex", flexDirection: "column", flexGrow: 1, height: "100%" }}>
          <PayerTransactionsTable
            paymentPreference={paymentPreference}
            showDisputedTransactions={showDisputedTransactions}
            showDisputedTransactionRows={showDisputedTransactionRows}
          />
        </Container>
      </Box>
    </>
  );
};

export default PayerDashboard;
